export const SupademoIcon = ({ className }: { className?: string }) => (
  <svg
    className={className}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 1443 1443"
    preserveAspectRatio="xMidYMid meet"
  >
    <circle cx="721.5" cy="721.5" r="720" fill="#000000" />
    <g transform="translate(0,1443) scale(0.1,-0.1)" stroke="none">
      <path
        fill="#ffffff"
        d="M7500 10175 c261 -13 573 -65 813 -135 475 -139 916 -411 1133 -699 140 -187 206 -371 207
-581 0 -166 -47 -290 -158 -408 -145 -155 -299 -222 -515 -222 -130 0 -222 19
-320 66 -103 49 -171 104 -245 199 -128 165 -195 295 -270 520 -73 223 -167
388 -304 537 -89 95 -187 162 -300 202 -83 30 -91 31 -256 31 -160 0 -175 -2
-250 -28 -114 -40 -178 -80 -268 -166 -123 -118 -193 -233 -233 -386 -27 -104
-25 -350 5 -460 71 -265 257 -482 528 -619 156 -78 478 -194 833 -301 268 -80
675 -222 840 -292 274 -117 481 -246 612 -380 139 -143 275 -365 336 -549 94
-281 111 -661 43 -925 -70 -270 -192 -472 -414 -685 -377 -362 -879 -568
-1577 -650 -186 -21 -662 -29 -880 -15 -678 46 -1208 205 -1637 491 -381 254
-563 542 -563 892 1 274 107 461 322 568 122 60 245 83 418 77 111 -3 149 -9
215 -30 114 -38 199 -91 285 -178 149 -151 249 -318 325 -539 55 -164 119
-296 193 -398 127 -179 224 -265 377 -337 149 -71 200 -80 430 -79 175 0 210
3 280 22 178 50 349 159 442 285 99 134 136 258 136 467 1 167 -13 237 -73
365 -67 145 -153 239 -340 372 -94 67 -145 98 -235 142 -93 45 -132 61 -147
61 -8 0 -18 4 -24 9 -16 15 -114 48 -244 81 -295 75 -838 233 -1073 311 -284
95 -528 244 -741 452 -269 263 -404 581 -435 1018 -26 362 47 673 223 947 234
365 687 676 1206 826 379 111 767 146 1300 121z"
      />
    </g>
  </svg>
);
